import React from "react"

interface DeviceStatsCardsProps {
	stats: {
		total: number
		online: number
		offline: number
	}
}

const DeviceStatsCards: React.FC<DeviceStatsCardsProps> = ({stats}) => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
			<div className="bg-blue-50 p-4 rounded-lg">
				<div className="text-2xl font-bold text-blue-600">{stats.total}</div>
				<div className="text-sm text-gray-600">Total Devices</div>
			</div>
			<div className="bg-green-50 p-4 rounded-lg">
				<div className="text-2xl font-bold text-green-600">{stats.online}</div>
				<div className="text-sm text-gray-600">Online</div>
			</div>
			<div className="bg-red-50 p-4 rounded-lg">
				<div className="text-2xl font-bold text-red-600">{stats.offline}</div>
				<div className="text-sm text-gray-600">Offline</div>
			</div>
		</div>
	)
}

export default DeviceStatsCards
